import { InjectionToken } from "@angular/core";

export interface Window {
  google?: IGoogle;
  navigator: Navigator;
}

export const WINDOW = new InjectionToken<Window>("Global window object", {
  factory: () => window as unknown as Window
});

export interface IGoogle {
  principal: IGooglePrincipal;
}

export interface IGooglePrincipal {
  initialize: (callback: () => void) => void;
  add: (details: IGoogleAddDetails, callback: () => void) => void;
  complete: (details: IGoogleCompleteDetails, callback: () => void) => void;
}

export interface IGoogleAddDetails {
  user: string;
  token: string;
  passwordBytes: string;
  keyType: "KEY_TYPE_PASSWORD_PLAIN";
}

export interface IGoogleCompleteDetails {
  token: string;
}
